<template>
    <rkm-overlay>
        <template v-if="centroCusto.setor.tipoId === enums.setorTipo.TRIAGEM">
            <rkm-layout-body title="Acolhimento">
                <rkm-layout-content>
                    <List />
                </rkm-layout-content>
            </rkm-layout-body>
        </template>

        <template v-else>
            <rkm-layout-body title="Acolhimento">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>TRIAGEM</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/pre-atendimento/List'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: {List},
    computed: {
        ...mapGetters({centroCusto: 'getCentroCusto'}),
    },
    data: () => ({
        enums: {setorTipo},
    }),
}
</script>